import React, { useState, useContext, useEffect, useRef } from 'react';
import { showError, showWait, dismissToast } from '../../../services/toast';
import { useNavigate } from 'react-router-dom';
import * as xlsx from 'xlsx';
import { LoginContext } from '../../../contexts/login_context';
import DataTable, { TableColumn } from 'react-data-table-component';
import BootyPagination from '../../../components/Pagination';
import { IoMdClose } from 'react-icons/io';
import Modal from 'react-modal';
import './style.css';
import { getAllGtinsRelacionados } from '../../../services/getAllGTINsRelacionados';
import { exportFileTest } from '../../../services/exportFileFrontEndGTIN';
import ExportDetail from '../../../components/ExportDetail';
import NewWarning from '../../../components/newWarning';
import { useSelector } from '../../../native-state.dev';

interface DataRow {
  gtinConsultado: string;
  descricaoConsultado: string;
  gtinRelacionado: string;
  descricaoRelacionado: string;
}

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

const SearchGTINsrelationship = () => {
  const [, setSearchDone] = useSelector((s: { searchDone: boolean }) => s.searchDone);
  const { jwt } = useContext(LoginContext);
  const navigate = useNavigate();
  const [name, setName] = useState<string | null>(null);
  const [v, setV] = useState('');
  const [startSearch, setStartSearch] = useState(false);
  const [code, setCode] = useState('');
  const unknown_text = 'Não cadastrado';
  const max_gtins_per_search = 10;
  const [details, setDetails] = useState<any>(null);
  const [view, setView] = useState(false);
  const [hasSearchError, setHasSearchError] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const myRef: any = useRef();
  const [valueCNPJ, setValueCNPJ] = useState('');
  const [isFocused, setFocused] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [chave, setChave] = useState<any>('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedGtins, setSelectedGtins] = useState<string[]>([]);
  const [selectedGtinsCsv, setSelectedGtinsCsv] = useState<string>('');
  const [ipsOpenModalConfirm, setIpsOpenModalConfirm] = useState(false);
  const [lastFilters, setLastFilters] = useState<any | null>(null);
  const [limitConfirmation, setLimitConfirmation] = useState<any | null>(null);
  const LS_KEY_REL = 'searchMany:pendingGtins';
  const closeChangeScreenModal = () => setIsModalOpen(false);
  const closeChangeScreenModalConfirm = () => setIpsOpenModalConfirm(false);

  let companyData: DataRow[] = [
    {
      gtinConsultado: unknown_text,
      descricaoConsultado: unknown_text,
      gtinRelacionado: unknown_text,
      descricaoRelacionado: unknown_text,
    },
  ];


    function validarGtins(lista: string[]) {
      const tamanhosValidos = [8, 12, 13, 14];

      const invalidos = lista.filter((gtin) => {
        const clean = gtin.replace(/\D/g, '');
        return !tamanhosValidos.includes(clean.length);
      });

      return invalidos;
    }



  const handleConfirmChangeScreen = () => {
    setIsModalOpen(false);
  };

  const [arrCompanies, setArrCompanies] = useState<DataRow[]>(companyData);
  const [originalArr, setOriginalArr] = useState<DataRow[]>(companyData);
  const [errorTitle, setErrorTitle] = useState('');
  const [errorMessage, setErrorMessage] = useState('');


   const handleConfirmarConsulta = async () => {
    const filtrosConfirmados = {
      confirmar: true,
    };

    await searchCodeComFiltros(filtrosConfirmados);

    setIpsOpenModalConfirm(false);
  };



    const searchCodeComFiltros = async (filtros: any) => {
      const gtins = v.replace(/\s+/g, '').split(',');

      const toastId = showWait('Reprocessando consulta...');
      setIsDisabled(true);

      try {
        const response = await getAllGtinsRelacionados(jwt, {
          ...filtros,
          gtins,
          tipoConsulta: chave,
        });

        dismissToast(toastId);
        setIsDisabled(false);

        if (!response.success || !response.result) {
          setView(false);
          setErrorTitle('Erro na consulta');
          setErrorMessage('Não foi possível reprocessar a consulta.');
          return;
        }

        const { data, mensagemLimite } = normalizeResult(response.result);

        if (mensagemLimite) {
          showError(mensagemLimite);
        }

        if (!data || data.length === 0) {
          setView(false);
          setErrorTitle('Nenhum resultado encontrado');
          setErrorMessage('Não há registros para exibir nesta consulta.');
          return;
        }

        setSearchDone({ searchDone: true });

        const companies: DataRow[] = data.map((item: any) =>
          mapItemToDataRow(item, chave)
        );

        setArrCompanies(companies);
        setOriginalArr(companies);
        setHasSearchError(false);
        setView(true);
        setStartSearch(true);
      } catch (error) {
        console.error(error);
        dismissToast(toastId);
        setIsDisabled(false);
        showError('Erro inesperado na consulta');
      }
    };


  const openChangeScreenModal = () => setIsModalOpen(true);

  const handleConsultarDadosProduto = () => {
    if (!selectedGtins?.length) {
      showError('Selecione pelo menos um GTIN na tabela para consultar os dados do produto.');
      return;
    }

    openChangeScreenModal();
  };

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [windowDimensions.height, windowDimensions.width]);

  async function handleGetFile(file: File) {
    try {
      const ext = String(file.name).split('.').pop()?.toLowerCase();

      if (ext === 'txt' || ext === 'csv') {
        const text = await file.text();

        const arr = text
          .split(/[\n,;]+/)
          .map((i) => i.trim())
          .filter((i) => i !== '');

        if (arr.length > max_gtins_per_search) {
          showError(`O arquivo pode conter no máximo ${max_gtins_per_search} códigos.`);
          return;
        }

        setV(arr.join(', '));
        return;
      }

      if (ext === 'xls' || ext === 'xlsx') {
        const buffer = await file.arrayBuffer();
        const workbook = xlsx.read(buffer, { type: 'array' });
        const workSheetName = workbook.SheetNames[0];
        const workSheet = workbook.Sheets[workSheetName];

        const data: any[][] = xlsx.utils.sheet_to_json(workSheet, {
          header: 1,
          blankrows: false,
        });

        const arr = data
          .flat()
          .map((cell) => String(cell).trim())
          .filter((v) => v !== '');

        if (arr.length > max_gtins_per_search) {
          showError(`O arquivo pode conter no máximo ${max_gtins_per_search} códigos.`);
          return;
        }

        setV(arr.join(', '));
        return;
      }

      showError('Formato de arquivo não suportado. Use .txt, .csv, .xls ou .xlsx.');
    } catch (error) {
      console.log(error);
      showError('Erro ao processar o arquivo.');
    }
  }

    const search = async (code: string | string[]) => {
      const gtins = Array.isArray(code) ? code : [code];

      const toastId = showWait('Aguarde, enquanto realizamos sua pesquisa.');
      setView(false);

      try {
        const response = await getAllGtinsRelacionados(jwt, {
          gtins,
          tipoConsulta: chave,
          ...(valueCNPJ && { cnpj: valueCNPJ }),
        });

        dismissToast(toastId);

        if (!response.success || !response.result) {
          setView(false);
          setHasSearchError(true);
          showError(response.message || 'Erro ao executar pesquisa.');
          return;
        }

        const result = response.result;

        setTimeout(() => {
            if (myRef && myRef.current) {
              myRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }
          }, 100);

        if (!Array.isArray(result) && result.requerConfirmacao) {
          const qtdDisponivel = Number(result.qtdDisponivel ?? 0);

          if (qtdDisponivel <= 0) {
            showError(
              'Sua busca excede o número disponível de consulta. Por favor, verificar a quantidade de consultas restantes na área de administrador.'
            );
            return;
          }

          setLimitConfirmation(result);
          setLastFilters({
            gtins,
            tipoConsulta: chave,
            ...(valueCNPJ && { cnpj: valueCNPJ }),
          });

          setIpsOpenModalConfirm(true);
          return;
        }

        const { data, mensagemLimite } = normalizeResult(result);

        if (mensagemLimite) {
          showError(mensagemLimite);
        }

        if (!data || data.length === 0) {
          setView(false);
          setHasSearchError(true);
          showError('Nenhum GTIN relacionado encontrado.');
          return;
        }

        setSearchDone({ searchDone: true });

        const companies: DataRow[] = data.map((item: any) =>
          mapItemToDataRow(item, chave)
        );

        setArrCompanies(companies);
        setOriginalArr(companies);
        setHasSearchError(false);
        setView(true);
        setStartSearch(true);
      } catch (error) {
        dismissToast(toastId);
        setHasSearchError(true);
        showError('Erro ao executar pesquisa.');
      }
    };


      function normalizeResult(result: any) {
        if (Array.isArray(result)) {
          return {
            data: result,
            mensagemLimite: undefined,
          };
        }

        if (result && Array.isArray(result.data)) {
          return {
            data: result.data,
            mensagemLimite: result.mensagemLimite,
          };
        }

        return {
          data: [] as any[],
          mensagemLimite: undefined,
        };
    }

  async function send() {
    if (name) {
      await search(v.replace(/\s+/g, '').split(','));
    } else {
      if (v === '') {
        showError(`Por favor, informe ao menos uma chave para consulta.`);
        return;
      }
      if (chave === '') {
        showError(`Por favor, informe ao menos uma opção de chave para consulta.`);
        return;
      }
      if (v.split(',').length > max_gtins_per_search) {
        showError(
          `Somente é possível pesquisar até ${max_gtins_per_search} números. Foi requisitado ${v.split(',').length} números para consulta.`,
        );
        return;
      }

      await search(
        v
          .replace(/\s+/g, '')
          .split(',')
          .filter((i) => i),
      );
    }
  }

  useEffect(() => {
    let retorno: any[] = originalArr.filter((d: any) => true);

    if (code !== '') {
      retorno = retorno.filter((d: any) =>
        String(d.gtinConsultado || '').includes(code),
      );
    }

    setArrCompanies(retorno as DataRow[]);
  }, [code, originalArr]);

  const columnsOrigem: TableColumn<DataRow>[] = [
    {
      name: 'GTIN',
      selector: (row) => row.gtinConsultado,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Descrição GTIN',
      selector: (row) => row.descricaoConsultado,
      sortable: true,
      wrap: true,
    },
    {
      name: 'GTIN Origem',
      selector: (row) => row.gtinRelacionado,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Descrição GTIN Origem',
      selector: (row) => row.descricaoRelacionado,
      sortable: true,
      wrap: true,
    },
  ];

  const columnsKit: TableColumn<DataRow>[] = [
    {
      name: 'GTIN Kit',
      selector: (row) => row.gtinConsultado,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Descrição GTIN Kit',
      selector: (row) => row.descricaoConsultado,
       sortable: true,
      wrap: true,
    },
    {
      name: 'GTIN Contido',
      selector: (row) => row.gtinRelacionado,
      sortable: true,
      wrap: true,
      style:{textAlign:'center'}
    },
    {
      name: 'Descrição GTIN Contido',
      selector: (row) => row.descricaoRelacionado,
      sortable: true,
      wrap: true,
    },
  ];

  const columns =
    chave === 'GTIN_KIT'
      ? columnsKit
      : chave === 'GTIN_ORIGEM'
      ? columnsOrigem
      : [];

  const customStyles = {
  rows: {
    style: {
      minHeight: '62px',
      fontFamily:
        "'-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'",
      fontSize: '0.94rem',
      color: '#002c6c',
      '&:nth-of-type(odd)': { backgroundColor: '#ffffff' },
      '&:nth-of-type(even)': { backgroundColor: '#e4e8ea' },
    },
  },
    headCells: {
      style: {
        justifyContent: 'flex-start',
        paddingLeft: '6px',
        paddingRight: '6px',
        fontFamily:
          "'-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'",
        fontSize: '0.94rem',
        color: '#002c6c',
      },
    },
    cells: {
      style: {
        justifyContent: 'flex-start', 
        paddingLeft: '6px',
        paddingRight: '6px',
        fontWeight: '500 !important',
      },
    },
    pagination: {
      style: {
        color: '#002c6c',
        fontFamily:
          "'-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'",
        fontSize: '0.94rem',
        minHeight: '56px',
      },
    },
  };

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    if (selectedValue) {
      setChave(selectedValue);
    }
  };

  const handleSelectedRowsChangeRelationship = (state: { selectedRows: any[] }) => {
    const gtins: string[] = Array.from(
      new Set(
        (state.selectedRows ?? [])
          .flatMap((row) => [
            row.GTIN,
            row.GTIN_KIT,
            row.GTIN_ORIGEM,
            row.GTIN_CONTIDO,
            row.gtinConsultado,
            row.gtinRelacionado,
          ])
          .map((v) => (v ?? '').toString())
          .map((s) => s.replace(/\D+/g, ''))
          .filter(Boolean),
      ),
    ).slice(0, 100);

    const csv = gtins.join(',');

    setSelectedGtins(gtins);
    setSelectedGtinsCsv(csv);
    localStorage.setItem(LS_KEY_REL, JSON.stringify(gtins));
  };

  function buildRelationshipRows(data: DataRow[], chave: string) {
    const normalizedKey = (chave || "").toUpperCase().trim();
    return data.map((row) => {
      if (normalizedKey === "GTIN_KIT") {
        return {
          "GTIN Kit": row.gtinConsultado,
          "Descrição GTIN Kit": row.descricaoConsultado,
          "GTIN Contido": row.gtinRelacionado,
          "Descrição GTIN Contido": row.descricaoRelacionado,
        };
      }
      return {
        "GTIN consultado": row.gtinConsultado,
        "Descrição GTIN consultado": row.descricaoConsultado,
        "GTIN relacionado": row.gtinRelacionado,
        "Descrição GTIN relacionado": row.descricaoRelacionado,
      };
    });
  }

  function mapItemToDataRow(item: any, chave: string): DataRow {
    const key = (chave || '').toUpperCase();

    if (key === 'GTIN_KIT') {
      return {
        gtinConsultado: item.GTIN_KIT || item.GTIN || '',
        descricaoConsultado:
          item.DESCRICAO_GTIN_KIT || item.DESCRICAO_GTIN || '',
        gtinRelacionado: item.GTIN_CONTIDO || item.GTIN_ORIGEM || '',
        descricaoRelacionado:
          item.DESCRICAO_GTIN_CONTIDO || item.DESCRICAO_GTIN_ORIGEM || '',
      };
    }

    return {
      gtinConsultado: item.GTIN || '',
      descricaoConsultado: item.DESCRICAO_GTIN || '',
      gtinRelacionado: item.GTIN_ORIGEM || '',
      descricaoRelacionado: item.DESCRICAO_GTIN_ORIGEM || '',
    };
  }

  const ValorDataPagina = arrCompanies.length;

  const textData = `Sua consulta retornou ${ValorDataPagina} GTINs. Caso queira consultar os dados de produtos, por favor, selecione os GTINs e clique no botão "Consultar os dados do produto"`;

  const handleContinuar = () => {
    if (!arrCompanies || arrCompanies.length === 0) {
      showError('Não há dados para exportar.');
      return;
    }

    const rows = buildRelationshipRows(arrCompanies, chave);

    exportFileTest(rows, 'xls');

    if (!localStorage.getItem(LS_KEY_REL)) {
      localStorage.setItem(LS_KEY_REL, JSON.stringify(selectedGtins));
    }

    navigate('/search-many');
  };

  return (
    <>
      {!details && (
        <>
          <div className="bg-color-ui-1 ">
            <div className="container customWithManyOtherGLN">
              <div className="row bg-color-white px-4 rounded-lg" style={{ margin: '0px' }}>
                <div className="customSpanOptions">
                </div>
                <div
                  className="col-12 col-md-12  aberto mb-4 customPaddingGLN"
                  style={{ marginTop: '-10px' }}
                >
                  <div className="form-group mb-0">
                    <select
                      style={{ height: '44px', padding: '0px', paddingLeft: '10px' }}
                      className="form-control"
                      id="selectId"
                      onChange={handleSelectChange}
                      defaultValue={''}
                    >
                      <option disabled value={''}>
                        Selecione uma opção
                      </option>
                      <option value="GTIN_ORIGEM">Consulta por GTIN Origem: Permite consultar GTINs com base em sua origem GTIN-8, GTIN-12 e GTIN-13 ou a partir do GTIN-14</option>
                      <option value="GTIN_KIT">Consulta por GTIN Kit: Permite consultar os códigos de produtos contidos no kit</option>
                    </select>
                  </div>
                  {/* {ShowIcon === false && (
                    <div style={{ marginTop: '10px' }}>
                      <div className="custom-border5" style={{ height: '44px', marginBottom: '10px' }}>
                        <label className="container_my_input_custom custom-height-container-input">
                          <BsSearch />
                          <input
                            id="inputId"
                            onFocus={() => setFocused(true)}
                            onBlur={() => setFocused(false)}
                            placeholder="CNPJ (opcional)"
                            onChange={({ target }) => setValueCNPJ(target.value)}
                            value={valueCNPJ}
                            className="especial_input"
                            style={{ outline: 'none', border: 'none' }}
                            disabled={isDisabled}
                          />
                        </label>
                      </div>
                    </div>
                  )} */}
                  <div className="row" style={{ marginBottom: '20px', maxWidth: '1050px' }}>
                    <textarea
                      onKeyDown={(e) => {
                        const nextValue = e.currentTarget.value;
                        const arr = nextValue
                          .split(',')
                          .map((i) => i.trim())
                          .filter((i) => i !== '');
                        if (arr.length >= max_gtins_per_search && (e.key === ',' || e.key === 'Enter')) {
                          e.preventDefault();
                        }
                      }}
                      onChange={({ target }) => {
                        let arr = target.value
                          .split(',')
                          .map((i) => i.trim())
                          .filter((i) => i !== '');

                        if (arr.length > max_gtins_per_search) {
                          arr = arr.slice(0, max_gtins_per_search);
                          setV(arr.join(', '));
                          return;
                        }

                        const invalidos = validarGtins(arr);
                        if (invalidos.length > 0) {
                          showError(
                            `GTINs inválidos: ${invalidos.join(', ')}. Os códigos devem ter 8, 12, 13 ou 14 dígitos.`
                          );
                        }

                        setV(target.value);
                      }}
                      onPaste={(e) => {
                        e.preventDefault();
                        const pasteText = e.clipboardData.getData('Text');

                        let arr = pasteText
                          .split(',')
                          .map((i) => i.trim())
                          .filter((i) => i !== '');

                        arr = arr.slice(0, max_gtins_per_search);

                        setV(arr.join(', '));
                      }}
                      value={v}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (e && e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                          handleGetFile(e.dataTransfer.files[0]);
                          e.dataTransfer.clearData();
                        }
                      }}
                      className="area"
                      placeholder="Pesquise até 10 código de barras (GTIN) por vez, digite aqui, separando por vírgulas, ou arraste e solte o arquivo (formatos .xlsx, .txt, .csv) para adicionar os GTIN"
                      id="textareaId"
                    ></textarea>
                  </div>

                  <div className="row pl-3" style={{ marginTop: '10px' }}>
                    <p>Upload de arquivo:</p>
                  </div>
                  <div className="buttonRowSearcManyCustom">
                    <label className="chooseFileCustom">
                      {name || 'Escolher arquivo'}
                      <input
                        onChange={(e) => {
                          if (e && e.target && e.target.files && e.target.files.length > 0) {
                            handleGetFile(e.target.files[0]);
                            e.target.value = '';
                          }
                        }}
                        style={{ opacity: '0', position: 'absolute', zIndex: '-1' }}
                        accept=".csv,.txt,.xls,.xlsx"
                        type="file"
                      />
                    </label>

                    <div className="btnSearchMultipleCustom">
                      <button className="btn btn-primary buttonEspecialGLNCustom" onClick={send}>
                        Buscar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div ref={myRef}></div>

          {startSearch === true && (
            <>
              {view && (
                <div className="bg-color-ui-1 pb-5 wp-home">
                  <div className="container">
                    <div className="row bg-color-white py-5 px-4 rounded-lg">
                      <div className="row">
                      <NewWarning
                        type="success"
                        showpick={false}
                        title=""
                        text={textData}
                      />
                    </div>
                      <div className="row" style={{ width: '100%' }}>
                        <div className="col-12 col-md-7 col-lg-9">
                          <h2 style={{ marginTop: 0, marginBottom: '0.5rem' }}>
                            Resultado da Pesquisa por GTINs Relacionados
                          </h2>
                        </div>
                      </div>
                      <div style={{width:'100%', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                          <div>
                            {view && arrCompanies.length > 0 && (
                              <ExportDetail className='relacionados-gtins' dataPrepared={arrCompanies} chave={chave} itemType={'REL_GTIN'} />
                            )}
                          </div>

                          <button
                            type="button"
                            className="custom-button-especial"
                            style={{ fontSize: '13px', width: '27%', marginTop: '20px' }}
                            disabled={isDisabled}
                            onClick={handleConsultarDadosProduto}
                          >
                            Consultar os dados do produto
                          </button>
                        </div>
                    </div>

                    <div className="row px-0 bg-color-white">
                      <div
                        className="col-12 px-0"
                        style={{ borderTop: 'solid 1px #d8d8d8' }}
                      >
                        <DataTable
                          columns={columns}
                          data={arrCompanies}
                          pagination
                          responsive
                          noDataComponent="Sem registros para exibir"
                          highlightOnHover
                          selectableRows
                          selectableRowsHighlight
                          customStyles={customStyles}
                          onSelectedRowsChange={handleSelectedRowsChangeRelationship}
                          paginationComponent={BootyPagination}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}

      <Modal
        isOpen={isModalOpen}
        contentLabel="Selected Option"
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#262626CC',
            zIndex: 1000,
          },
          content: {
            maxWidth: '485px',
            height: '270px',
            marginTop: '5%',
            marginBottom: 0,
            marginLeft: 'auto',
            marginRight: 'auto',
            zIndex: 1000,
            border: '1px solid #ccc',
            background: '#fff',
            overflow: 'auto',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '20px',
            outline: 'none',
            padding: '10px',
          },
        }}
      >
        <div style={{ padding: '0.5rem' }}>
          <span
            onClick={closeChangeScreenModal}
            style={{ position: 'absolute', right: '7px', top: '7px', cursor: 'pointer' }}
            aria-label="Fechar modal"
            title="Fechar"
          >
            <IoMdClose />
          </span>

          <div style={{ display: 'flex', flexDirection: 'column', rowGap: '2rem' }}>
            <div style={{ color: 'rgb(105, 109, 115)', marginBottom: '-15px' }}>
              <div className="section">
                <div
                  className="custom-col12 col-md-12"
                  style={{ display: 'flex', fontSize: '17px' }}
                >
                  <div
                    className="w-1/2 md:w-full table-responsive"
                    style={{ textAlign: 'left', lineHeight: '1.3' }}
                  >
                    <div
                      className="custom-fontSize"
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '180px',
                        textAlign: 'justify',
                      }}
                    >
                      <div
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          marginBottom: '20px',
                        }}
                      >
                        <span style={{ fontWeight: 'bold', color: '#002C6C' }}>
                          Aviso de redirecionamento
                        </span>
                      </div>
                      <div className="flex" style={{ display: 'grid', gap: 8 }}>
                        <div>
                          Você será redirecionado para a aba de consulta múltipla e não poderá
                          retornar à tela anterior. Ao clicar em <strong>Continuar</strong>, a
                          consulta atual será baixada.
                        </div>
                      </div>
                    </div>

                    <div
                      className="custom-display-buttons"
                      style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}
                    >
                      <div
                        className="sm: mt-0"
                        style={{ textAlign: 'right', marginTop: '-15px' }}
                      >
                        <button
                          style={{ maxWidth: '170px', marginRight: '10px' }}
                          className="btn btn-outline-primary custom-fontSize"
                          onClick={handleConfirmChangeScreen}
                        >
                          Cancelar
                        </button>
                      </div>

                      <div
                        className="sm: mt-0"
                        style={{ textAlign: 'right', marginTop: '-15px' }}
                      >
                        <button
                          style={{ maxWidth: '170px' }}
                          className="btn btn-primary custom-fontSize"
                          onClick={handleContinuar}
                        >
                          Continuar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={ipsOpenModalConfirm}
        contentLabel="Selected Option"
        style={{
          overlay: {
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "#262626CC",
            zIndex: 1000,
          },
          content: {
            maxWidth: "485px",
            height: "270px",
            marginTop: "5%",
            marginBottom: 0,
            marginLeft: "auto",
            marginRight: "auto",
            zIndex: 1000,
            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "20px",
            outline: "none",
            padding: "10px",
          },
        }}
      >
        <div style={{ padding: "0.5rem" }}>
          <span
            onClick={closeChangeScreenModalConfirm}
            style={{ position: "absolute", right: "7px", top: "7px", cursor: 'pointer' }}
            aria-label="Fechar modal"
            title="Fechar"
          >
            <IoMdClose />
          </span>

          <div style={{ display: "flex", flexDirection: "column", rowGap: "2rem" }}>
            <div style={{ color: "rgb(105, 109, 115)", marginBottom: "-15px" }}>
              <div className="section">
                <div className="custom-col12 col-md-12" style={{ display: "flex", fontSize: "17px" }}>
                  <div className="w-1/2 md:w-full table-responsive"
                       style={{ textAlign: "left", lineHeight: "1.3" }}>
                    <div className="custom-fontSize"
                         style={{
                           display: "flex",
                           flexDirection: "column",
                           justifyContent: "center",
                           alignItems: "center",
                           height: "180px",
                           textAlign: "justify",
                         }}>
                      <div style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "20px",
                      }}>
                        <span style={{ fontWeight: "bold", color:'#002C6C'}}>
                         Atenção!
                        </span>
                      </div>
                      <div className="flex" style={{ display: 'grid', gap: 8 }}>
                        <div>
                          Identificamos que a quantidade de códigos disponível na página selecionada é superior ao limite disponível da empresa. Ao clicar em "Continuar", a consulta será realizada, mas <strong>será entregue apenas a quantidade disponível do limite da sua empresa.</strong>
                        </div>
                      </div>
                    </div>

                    <div className="custom-display-buttons" style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop:10}}>
                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button
                          style={{ maxWidth: "170px", marginRight: "10px" }}
                          className="btn btn-outline-primary custom-fontSize"
                          onClick={()=>{setIpsOpenModalConfirm(false)}}
                        >
                          Cancelar
                        </button>
                      </div>

                      <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                        <button
                          style={{ maxWidth: "170px" }}
                          className="btn btn-primary custom-fontSize"
                          onClick={()=>{handleConsultarDadosProduto(); setIpsOpenModalConfirm(false)}}
                        >
                          Continuar
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </Modal>


      <Modal
              isOpen={ipsOpenModalConfirm}
              contentLabel="Selected Option"
              style={{
                overlay: {
                  position: "fixed",
                  top: 0, left: 0, right: 0, bottom: 0,
                  backgroundColor: "#262626CC",
                  zIndex: 1000,
                },
                content: {
                  maxWidth: "485px",
                  height: "270px",
                  marginTop: "5%",
                  marginBottom: 0,
                  marginLeft: "auto",
                  marginRight: "auto",
                  zIndex: 1000,
                  border: "1px solid #ccc",
                  background: "#fff",
                  overflow: "auto",
                  WebkitOverflowScrolling: "touch",
                  borderRadius: "20px",
                  outline: "none",
                  padding: "10px",
                },
              }}
            >
              <div style={{ padding: "0.5rem" }}>
                <span
                  onClick={closeChangeScreenModalConfirm}
                  style={{ position: "absolute", right: "7px", top: "7px", cursor: 'pointer' }}
                  aria-label="Fechar modal"
                  title="Fechar"
                >
                  <IoMdClose />
                </span>
      
                <div style={{ display: "flex", flexDirection: "column", rowGap: "2rem" }}>
                  <div style={{ color: "rgb(105, 109, 115)", marginBottom: "-15px" }}>
                    <div className="section">
                      <div className="custom-col12 col-md-12" style={{ display: "flex", fontSize: "17px" }}>
                        <div className="w-1/2 md:w-full table-responsive"
                             style={{ textAlign: "left", lineHeight: "1.3" }}>
                          <div className="custom-fontSize"
                               style={{
                                 display: "flex",
                                 flexDirection: "column",
                                 justifyContent: "center",
                                 alignItems: "center",
                                 height: "180px",
                                 textAlign: "justify",
                               }}>
                            <div style={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                              marginBottom: "20px",
                            }}>
                              <span style={{ fontWeight: "bold", color:'#002C6C'}}>
                               Atenção!
                              </span>
                            </div>
                            <div className="flex" style={{ display: 'grid', gap: 8 }}>
                              <div>
                                Identificamos que a quantidade de códigos disponível na página selecionada é superior ao limite disponível da empresa. Ao clicar em "Continuar", a consulta será realizada, mas <strong>será entregue apenas a quantidade disponível do limite da sua empresa.</strong>
                              </div>
                            </div>
                          </div>
      
                          <div className="custom-display-buttons" style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop:10}}>
                            <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                              <button
                                style={{ maxWidth: "170px", marginRight: "10px" }}
                                className="btn btn-outline-primary custom-fontSize"
                                onClick={()=>{setIpsOpenModalConfirm(false)}}
                              >
                                Cancelar
                              </button>
                            </div>
      
                            <div className="sm: mt-0" style={{ textAlign: "right", marginTop: "-15px" }}>
                              <button
                                style={{ maxWidth: "170px" }}
                                className="btn btn-primary custom-fontSize"
                                onClick={handleConfirmarConsulta}
                              >
                                Continuar
                              </button>
                            </div>
                          </div>
      
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
      
              </div>
            </Modal>
    </>
  );
};

export default SearchGTINsrelationship;
